<template>
    <div class="o-guide-footer guide-footer">
        <div class="guide-footer__column">
            <AButton
                class="guide-footer__button"
                :text="$t('ui.send-sms')"
                @onClick="showSmsModal"
            />
            <ABackButton
                class="guide-footer__button"
                :text="$t('ui.back')"
                :route="defineBackRoute"
            />
        </div>
        <div class="guide-footer__column guide-footer__qr">
            <OQrGenerator />
        </div>
    </div>
</template>

<script>
import AButton from '../../atoms/a-button/a-button';
import ABackButton from '../../atoms/a-back-button/a-back-button';
import OQrGenerator from '../../organisms/o-qr-code-generator/o-qr-code-generator';

import { SHOW_MODAL} from "../../../utils/constants/bus-events-constants";

export default {
    name: 'OGuideFooter',
    components: {
        AButton,
        ABackButton,
        OQrGenerator
    },
    computed: {
        defineBackRoute() {
            return this.$route.params.type;
        },
        itemId() {
            return parseInt(this.$route.params.id, 10);
        },
    },
    methods: {
        showSmsModal() {
            const params = {
                component: 'sms',
                data: {
                    itemId: ''
                }
            };
            this.$bus.$emit(SHOW_MODAL, params);
        }
    }
}
</script>

<style lang="scss">
@import "o-guide-footer";
</style>
